/**
 * Rounds the Number object to two decimal places.
 * @param {Number} number
 * @returns {Number} rounded to two decimal places, 0 if the given param is invalid
 */
export const roundToTwoDecimalPlaces = number => {
    return number ? +(Math.round(number + 'e+2') + 'e-2') : 0;
};

/**
 * Parses a locale-aware numeric string, accepting both "." and "," as decimal separator.
 * @param {string|number} value
 * @returns {number} parsed number, or NaN if invalid
 */
export const parseLocaleNumber = value => {
    if (value === '' || value == null) return NaN;
    const normalized = String(value).replace(',', '.');
    return parseFloat(normalized);
};

/**
 * Formats the Number object to two decimal places.
 * @param {Number} number
 * @returns {String} number formatted to two decimal places. '0.00' if given number object is false/invalid
 */

export const formatNumberToTwoDecimalPlaces = number => {
    return number ? number.toFixed(2) : '0.00';
};
